<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-12">
        <p class="has-text-link has-text-weight-bold is-size-4">
          {{ $t('detailContrat.infoBail.code', { code: contrat.code }) }}
          <b-tag type="has-background-subMenu" class="has-text-white" v-if="contrat.estIndexe">
            {{ $t('detailContrat.indexation.estIndexe') }}
          </b-tag>
        </p>
        <p class="has-text-default">
          {{ $t('detailContrat.infoBail.typeBail', { type: $t(getType) }) }}
        </p>
        <p class="has-text-default">
          {{ $t('detailContrat.infoBail.natureBail', { nature: contrat.nature.libelle }) }}
        </p>
        <p class="has-text-default" v-if="moduleSecteurActive">
          {{ $t('detailContrat.infoBail.secteur', { secteur: getLibelleSecteur() }) }}
        </p>
      </div>
      <div class="column is-4">
        <p class="mgb-10px has-text-default has-text-weight-bold">
          {{ $t('detailContrat.infoBail.contrat.title') }}
        </p>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.contrat.periodeContrat')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ $t('detailContrat.infoBail.contrat.periode',
                { dateDebut: getDate(contrat.dateDebutSignature),
                  dateFin: getDate(contrat.dateFinSignature),
                  periode: getDifferenceBetweenDateLibelleYearsMonthsDays(
            contrat.dateDebutSignature, contrat.dateFinSignature)}) }}
          </span>
          </b-field>
        </div>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.contrat.periodeEcheancier')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ $t('detailContrat.infoBail.contrat.periode',
                { dateDebut: getDate(contrat.dateDebutEcheance),
                  dateFin: getDate(contrat.dateFinEcheance),
                  periode: getDifferenceBetweenDateLibelleYearsMonthsDays(
            contrat.dateDebutEcheance, contrat.dateFinEcheance)}) }}
          </span>
          </b-field>
        </div>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.contrat.echeanceTousLes')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ $t('detailContrat.infoBail.contrat.periodeEcheance',
            { unite: $t(getPeriodicite(contrat.unitePeriodicite)),
              quantite: contrat.quantitePeriodicite } ) }}
          </span>
          </b-field>
        </div>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.contrat.datePreavis')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ contrat.datePreavis | formatDate }}
          </span>
          </b-field>
        </div>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.contrat.dateSignature')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ contrat.dateSignature | formatDate }}
          </span>
          </b-field>
        </div>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.contrat.signataire')"
                  custom-class="has-text-default is-italic has-text-weight-light mgb-0">
            <span class="has-text-link has-text-weight-bold">
              {{ contrat.signataire ? contrat.signataire.libelle : "&nbsp;" }}
            </span>
          </b-field>
        </div>
        <div class="mgb-20px">
          <b-field grouped>
            <b-field
              :label="$t('detailContrat.infoBail.contrat.demarcheur')"
              custom-class="has-text-default is-italic has-text-weight-light mgb-0">
              <router-link-blank
                v-if="getDemarcheur"
                v-bind="getDemarcheur">
              </router-link-blank>
            </b-field>
            <b-field :label="$t('detailContrat.infoBail.contrat.commission')" class=" mgl-10px"
                    custom-class="has-text-default is-italic has-text-weight-light mgb-0">
              <span class="has-text-link has-text-weight-bold">
                {{ getCommission(contrat.commission) }}
              </span>
            </b-field>
            <b-field :label="$t('detailContrat.infoBail.contrat.responsableBail')" class=" mgl-10px"
                    custom-class="has-text-default is-italic has-text-weight-light mgb-0">
              <span class="has-text-link has-text-weight-bold" v-if="contrat.responsableBailId">
                {{ contrat.responsableBail.nom }} {{contrat.responsableBail.prenom}}
              </span>
            </b-field>
          </b-field>
        </div>
      </div>
      <div class="column is-4">
        <p class="mgb-10px has-text-default has-text-weight-bold">
          {{ $t('detailContrat.infoBail.bailleurs.title') }}
        </p>
        <div class="mgb-20px" v-for="intervenant in contrat.intervenants"
             :key="intervenant.id">
          <b-field class="mgb-0">
            <div class="has-text-link is-size-5 has-text-weight-bold">
              {{ intervenant.tiers.nomCommercial }}
            </div>
            <router-link-blank :to="{ name: 'c.baux.bailleur',
                                      params: { id: intervenant.tiersId } }" icon="open-in-new"
                               classMessage="mgl-10px"
                               typeIcon="is-primary" sizeIcon="is-small">
            </router-link-blank>
          </b-field>
          <div class="has-text-default">
            {{ getAdresse(intervenant.tiers.adressePostale) }}
            <br>
            {{ $t('detailContrat.infoBail.bailleurs.quotePart',
            { quotePart: intervenant.repartition}) }}
            <br>
            {{ $t('detailContrat.infoBail.bailleurs.paiement',
            { paiement: getModeReglement(intervenant.modeReglementId) }) }}
            <br>
            {{ $t('detailContrat.infoBail.bailleurs.surFacture')}}
            {{ intervenant.surFacture ? $t('detailContrat.infoBail.bailleurs.yes')
            : $t('detailContrat.infoBail.bailleurs.no') }}
            <br>
            {{ $t('detailContrat.infoBail.bailleurs.email')}}
            {{ intervenant.tiers.email }}
            <br>
            {{ $t('detailContrat.infoBail.bailleurs.telephone')}}
            {{ intervenant.tiers.portable !== "" ? intervenant.tiers.portable
            : intervenant.tiers.telephone }}
          </div>
        </div>
      </div>
      <div class="column is-4">
        <p class="mgb-10px has-text-default has-text-weight-bold">
          {{ $t('detailContrat.infoBail.infoFinancieresLoyer.title') }}
        </p>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.infoFinancieresLoyer.montantHt')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ contrat.loyerAnnuelHt | formatDevise }}
          </span>
          </b-field>
        </div>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.infoFinancieresLoyer.tauxTva')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ $t('detailContrat.infoBail.infoFinancieresLoyer.tva',
            { tva: contrat.tauxTva }) }}
          </span>
          </b-field>
        </div>
        <div class="mgb-20px">
          <b-field :label="$t('detailContrat.infoBail.infoFinancieresLoyer.montantTtc')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ contrat.loyerAnnuelTtc | formatDevise }}
          </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import getDifferenceBetweenDateLibelleYearsMonthsDays from '@/services/baux/contrat/getDifferenceBetweenDateLibelleYearsMonthsDays';
import { LISTE_TYPE_CONTRAT } from '@/configuration/baux/contrat/contratConf';
import { TIERS_SOUS_TYPE_DEMARCHEUR } from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';
import { LISTE_UNITES } from '@/configuration/devisConf';
import { formatDevise } from '@/services/general/filters/formatDevise';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    contrat: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    getType() {
      const typeFind = LISTE_TYPE_CONTRAT.find((type) => {
        return type.code === this.contrat.type;
      });
      return typeFind ? typeFind.libelle : null;
    },
    getDemarcheur() {
      if (!this.contrat?.fournisseurDemarcheur) return null;
      return {
        message: this.contrat.fournisseurDemarcheur.nomCommercial,
        to: {
          name: 'c.baux.demarcheur',
          params: {
            id: this.contrat.fournisseurDemarcheurId,
            sousTypeFrom: TIERS_SOUS_TYPE_DEMARCHEUR,
          },
        },
      };
    },
    secteurs() {
      return this.parametre(PARAMETRES_KEYS.secteur);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getPeriodicite(periodiciteCode) {
      const periodiciteFind = LISTE_UNITES.find((periodicite) => {
        return periodicite.code === periodiciteCode;
      });
      return periodiciteFind ? periodiciteFind.libelleLight : '';
    },
    getDate(date) {
      return formatDate(date);
    },
    getCommission(commission) {
      if (commission === null) return '';
      return formatDevise(commission);
    },
    getModeReglement(modeReglementId) {
      const modeReglement = this.parametre(PARAMETRES_KEYS.modeReglement).find((mode) => {
        return mode.id === modeReglementId;
      });
      return modeReglement ? modeReglement.libelle : null;
    },
    getAdresse(adresse) {
      return adressFullStringGetter(adresse);
    },
    getDifferenceBetweenDateLibelleYearsMonthsDays(dateDebut, dateFin) {
      return getDifferenceBetweenDateLibelleYearsMonthsDays(dateDebut, dateFin, this.$i18n);
    },
    getLibelleSecteur() {
      return this.secteurs.find(s => s.id === this.contrat.secteur?.secteurId)?.libelle
      ?? '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.modeReglement,
        PARAMETRES_KEYS.secteur,
      ]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
